<template>
  <resource-create-wrapper
    :title="$t('resources.authors.new_author')"
    :need-modal="showModal"
    @saveAction="$refs['authorForm'].submit()">
    <AuthorForm :author="item" @isDirtyForm="isDirtyForm" ref="authorForm"></AuthorForm>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import AuthorForm from "@/components/forms/AuthorForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      AuthorForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      /**
       * Item is provided here when duplicating
       */
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
